interface BarberPhotoProps {
  src: string;
  alt: string;
  zoom?: number;       // 1.0 = no zoom, 1.5 = 50% zoom in (default 1.0)
  yOffset?: string;   // CSS object-position Y (default "15%")
}

export function BarberPhoto({ src, alt, zoom = 1.0, yOffset = "15%" }: BarberPhotoProps) {
  return (
    <div className="absolute inset-0 overflow-hidden">
      <img
        src={src}
        alt={alt}
        className="h-full w-full object-cover"
        style={{
          objectPosition: `center ${yOffset}`,
          transform: `scale(${zoom})`,
          transformOrigin: `center ${yOffset}`,
        }}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
}




